export const LIST_HOLIDAYS_REQUEST = 'LIST_HOLIDAYS_REQUEST'
export const LIST_HOLIDAYS_SUCCESS = 'LIST_HOLIDAYS_SUCCESS'
export const LIST_HOLIDAYS_FAIL = 'LIST_HOLIDAYS_FAIL'

export const LIST_HOLIDAYS_SUMMARY_REQUEST =
  'LIST_HOLIDAYS_SUMMARY_REQUEST'
export const LIST_HOLIDAYS_SUMMARY_SUCCESS =
  'LIST_HOLIDAYS_SUMMARY_SUCCESS'
export const LIST_HOLIDAYS_SUMMARY_FAIL =
  'LIST_HOLIDAYS_SUMMARY_FAIL'

export const CREATE_HOLIDAYS_REQUEST = 'CREATE_HOLIDAYS_REQUEST'
export const CREATE_HOLIDAYS_SUCCESS = 'CREATE_HOLIDAYS_SUCCESS'
export const CREATE_HOLIDAYS_FAIL = 'CREATE_HOLIDAYS_FAIL'

export const DETAIL_HOLIDAYS_REQUEST = 'DETAIL_HOLIDAYS_REQUEST'
export const DETAIL_HOLIDAYS_SUCCESS = 'DETAIL_HOLIDAYS_SUCCESS'
export const DETAIL_HOLIDAYS_FAIL = 'DETAIL_HOLIDAYS_FAIL'

export const UPDATE_HOLIDAYS_REQUEST = 'UPDATE_HOLIDAYS_REQUEST'
export const UPDATE_HOLIDAYS_SUCCESS = 'UPDATE_HOLIDAYS_SUCCESS'
export const UPDATE_HOLIDAYS_FAIL = 'UPDATE_HOLIDAYS_FAIL'

export const DELETE_HOLIDAYS_REQUEST = 'DELETE_HOLIDAYS_REQUEST'
export const DELETE_HOLIDAYS_SUCCESS = 'DELETE_HOLIDAYS_SUCCESS'
export const DELETE_HOLIDAYS_FAIL = 'DELETE_HOLIDAYS_FAIL'

export const RESET_HOLIDAYS = 'RESET_HOLIDAYS'
